import { createContext, useContext } from "react";

const noWorkspaceSwitchLoader = () => undefined;

const WorkspaceSwitchLoaderContext = createContext<() => void>(noWorkspaceSwitchLoader);

/** App supplies the start of its single loader hold for a workspace switch. */
export const WorkspaceSwitchLoaderProvider = WorkspaceSwitchLoaderContext.Provider;

/**
 * Starts the branded loader for a real workspace switch. Call it in the same
 * event as the switch, so the loader covers the first frame of the new context.
 */
export function useBeginWorkspaceSwitch(): () => void {
  return useContext(WorkspaceSwitchLoaderContext);
}
